<!--
  @修改人：黎柏祺
  @修改时间：2018-11-27
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @修改人：黎柏祺
  @修改时间：2018-04-26
  @修改描述：更换图表风格
  @版本:v1.0.16
  --------
  @负责人: 谢汉
  @创建时间: 2018-01-18
  @版本:v1.0.12
  @描述: 日志量分析页面
  -->
<template>
  <div class="logCountAnalysis__content">
    <div class="logCountAnalysis__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('logCountAnalysis.time')">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
          {{$t('common.to')}}
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.site')">
          <g-select :list="siteList" v-model="form.siteCode"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logCountAnalysis.group')">
          <g-select :list="select_group" v-model="form.group"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logCountAnalysis.appName')">
          <g-select :list="select_appName" v-model="form.appName"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logCountAnalysis.IP')">
          <g-select :list="select_IP" v-model="form.ip"></g-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-g-rac="gRac('logCountAnalysis_search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="chart-auto" :style="screenWidth">
        <chart-config-list v-show="appChartData.length !== 0" :chart-data-list="appChartData"></chart-config-list>
        <div v-show="appChartData.length === 0"  v-text="$t('common.noData')" style="text-align: center"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import chartConfigList from '@/components/chart/chart-config-list.vue'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import appDetailBiz from '@/logic/intelligentMonitor/appDetailBiz'
  import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'

  export default {
    mixins: [rac, dic],
    data () {
      return {
        siteList: {},
        form: {
          siteCode: '',
          group: '',
          appName: '',
          startTime: '',
          endTime: '',
          ip: ''
        },
        select_group: {},
        select_appName: {},
        select_IP: {},
        logChartData: [{
          normal: {},
          data: []
        }],
        logChartTime: [],
        logChartLegend: [],
        showChart: false,
        screenWidth: {
          width: ''
        },
        appChartData: [],
        group: '',
        appHostIpList: {},
        app: ''
      }
    },
    computed: {},
    methods: {
      e_init () {
        this.form.startTime = new Date().getTime() - 24 * 60 * 60 * 1000
        this.form.endTime = new Date().getTime()
        this.getSiteList()
      },
      getSiteList () {
        if (Object.keys(this.siteList).length > 0) {
          this.search()
        } else {
          cmdbBiz.siteList({perPageCount: 500}).then((data) => {
            let list = {}
            data.dataList.map((item) => {
              list[item.siteCode] = item.name
            })
            this.siteList = list
            this.form.siteCode = Object.keys(list)[0]
            this.waitGroupList(this.form.siteCode)
          })
        }
      },
      async waitGroupList (siteCode, siteChange) {
        await this.dGetGroup(siteCode, siteChange)
        this.select_group = this.$store.state.dicModule.group
        this.form.group = Object.keys(this.select_group)[0]
      },
      async waitAppList () {
        await this.dGetAppByGroup(this.form.siteCode, this.form.group)
        this.select_appName = { ...this.dDictionaryApp[this.form.group] }
        this.form.appName = Object.keys(this.select_appName)[0]
      },
      e_getIP () {
        if (this.form.group && this.form.appName) {
          cmdbBiz.ipList({
            groups: this.form.group,
            applications: this.form.appName
          }).then((data) => {
            this.select_IP = {}
            data.forEach((item) => {
              this.select_IP[item] = item
            })
            this.form.ip = Object.keys(this.select_IP).length !== 0 ? Object.keys(this.select_IP)[0] : ''
            this.search()
          })
        }
      },
      getIpList () {
        appDetailBiz.getAppIPAndPort(this.form.group, this.form.appName).then((data) => {
          this.appHostIpList = data
          this.getAppKpiMap()
        })
      },
      getAppKpiMap () {
        appDetailBiz.getKpiMapData(this.form.group, this.form.appName, '3', this.form.siteCode).then((data) => {
          let promiseList = []
          let promiseRes = []
          if (this.form.startTime < this.form.endTime) {
            if (this.form.ip !== '') {
              data.map(item => {
                let searchData = {
                  startTime: this.form.startTime,
                  endTime: this.form.endTime,
                  ip: this.form.ip,
                  kpiKey: item.kpiKey,
                  appName: item.appName,
                  group: item.group,
                  siteCode: item.siteCode
                }
                promiseList.push(this.getChartData(searchData, item.desc === '' ? item.kpiKey : item.desc, item.fields[0].format))
              })
              Promise.all(promiseList).then((res) => {
                res.map(_item => {
                  promiseRes.push(_item)
                })
                this.drawChart(promiseRes)
              })
            } else {
              this.$message({
                message: this.$t('logCountAnalysis.ipAlert'),
                type: 'warning'
              })
            }
          } else {
            this.$message({
              message: this.$t('logCountAnalysis.timeAlert'),
              type: 'warning'
            })
          }
        })
      },
      getChartData (searchData, desc, format) {
        return new Promise((resolve, reject) => {
          ITDeviceMonitorBiz.getChartData(searchData).then((data) => {
            resolve({ title: desc,
              data: data,
              format: format,
              kpiKey: searchData.kpiKey,
              appName: searchData.appName,
              group: searchData.group,
              siteCode: searchData.siteCode })
          }).catch(err => {
            reject(err)
          })
        })
      },
      drawChart (dataList) {
        const list = []
        this.appChartData = []
        dataList.map((item, index) => {
          const chartData = {
            title: item.title,
            chartId: `${item.title}-${index}`,
            chartData: {
              rows: item.data ? item.data : [],
              columns: ['eventTime', 'value'],
              formatMap: {
                eventTime: 'TIME',
                value: item.format
              },
              labelMap: {
                value: item.title
              }
            },
            kpiInfo: {
              appGroup: item.group,
              kpiKey: item.kpiKey,
              appName: item.appName,
              siteCode: item.siteCode
            }
          }
          list.push(chartData)
        })
        this.appChartData = list
      },
      search () {
        this.getIpList()
      }
    },
    components: {
      chartConfigList
    },
    mounted () {
      this.e_init()
    },
    watch: {
      'form.group' () {
        this.waitAppList()
      },
      'form.appName' () {
        this.e_getIP()
      },
      'form.siteCode': function (val) {
        this.waitGroupList(val, true)
      }
    }
  }
</script>
      
<style scoped>
  .logCountAnalysis__content {
    height: 100%;
  }
  .chart-auto {
      height: 400px;
      margin: 20px auto;
  }
</style>